module.exports = __webpack_public_path__ + "img/banner.c8f8dca7.png";